<template>
    <p>Menu Due</p>
</template>

<script>
export default {
    data() {
        return {};
    },
    created() {
        console.log("Menu Due");
    },
};
</script>

<style></style>
